import api from '../api';

export const getUsers = filters =>
  api.request({
    url: `user`,
    method: 'GET',
    params: filters,
  });

export const requestUser = id =>
  api.request({
    url: `user/${id}`,
    method: 'GET',
  });

export const editUser = (id, data) =>
  api.request({
    url: `user/by_id/${id}`,
    method: 'PUT',
    data,
  });

export const editUserLocation = (id, data) =>
  api.request({
    url: `address/admin/${id}`,
    method: 'PUT',
    data,
  });

export const banishUser = (id, data) =>
  api.request({
    url: `user/ban/${id}`,
    method: 'PATCH',
    data,
  });

// Backend response shape (after report.service.ts findAll/findOne with relations):
// {
//   id: string (UUID),
//   reason: string,
//   user: { id, firstName, lastName, email, ... },          // reportante
//   reportedUser: { id, firstName, lastName, email, ... },  // reportado
//   created_at: string (ISO),
//   updated_at: string (ISO),
// }
export const getReports = () =>
  api.request({
    url: `report`,
    method: 'GET',
    // Backend marks /report (list) as @BasicAuth() — use the admin's Basic Auth flow
    // instead of Bearer. See src/services/api.js for the interceptor.
    headers: { noAuth: true },
  });

export const getReportDetail = id =>
  api.request({
    url: `report/${id}`,
    method: 'GET',
  });
